import React, { useState } from 'react';
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import { API_ENDPOINTS } from '../config';  // Import the updated config

const AddProductPage = () => {
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        price: '',
        mrp: '',
        sellingPrice: '',
        lotSize: '',
        manufacturerName: '',
        discount: '',
        image: null  // Add image field to store file object
    });

    const handleChange = (e) => {
        if (e.target.name === 'image') {
            // Handle file upload separately
            setFormData({ ...formData, image: e.target.files[0] });
        } else {
            const { name, value } = e.target;
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const formDataToSend = new FormData();
            formDataToSend.append('name', formData.name);
            formDataToSend.append('description', formData.description);
            formDataToSend.append('price', formData.price);
            formDataToSend.append('mrp', formData.mrp);
            formDataToSend.append('sellingPrice', formData.sellingPrice);
            formDataToSend.append('lotSize', formData.lotSize);
            formDataToSend.append('manufacturerName', formData.manufacturerName);
            formDataToSend.append('discount', formData.discount);
            if (formData.image) {
                formDataToSend.append('image', formData.image);
            }

            const response = await axios.post(API_ENDPOINTS.createProduct, formDataToSend, {  // Use updated endpoint
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            console.log('Product added successfully:', response.data);
            // Reset form after successful submission (optional)
            setFormData({
                name: '',
                description: '',
                price: '',
                mrp: '',
                sellingPrice: '',
                lotSize: '',
                manufacturerName: '',
                discount: '',
                image: null
            });
        } catch (error) {
            console.error('Error adding product:', error);
            // Handle error state or display error message to user
        }
    };

    return (
        <Container>
            <Row className="justify-content-md-center mt-4">
                <Col xs={10} md={8} lg={6}>
                    <h2 className="text-center mb-4">Add New Product</h2>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="productName">
                            <Form.Label>Product Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter product name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group controlId="productDescription">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Enter product description"
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>

                        <Row>
                            <Col>
                                <Form.Group controlId="productPrice">
                                    <Form.Label>Price</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Enter price"
                                        name="price"
                                        value={formData.price}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="productMRP">
                                    <Form.Label>MRP</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Enter MRP"
                                        name="mrp"
                                        value={formData.mrp}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Form.Group controlId="productSellingPrice">
                                    <Form.Label>Selling Price</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Enter selling price"
                                        name="sellingPrice"
                                        value={formData.sellingPrice}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId="productLotSize">
                                    <Form.Label>Lot Size</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Enter lot size"
                                        name="lotSize"
                                        value={formData.lotSize}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Form.Group controlId="productManufacturer">
                            <Form.Label>Manufacturer Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter manufacturer name"
                                name="manufacturerName"
                                value={formData.manufacturerName}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group controlId="productDiscount">
                            <Form.Label>Discount (%)</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="Enter discount percentage"
                                name="discount"
                                value={formData.discount}
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>

                        <Form.Group controlId="productImage">
                            <Form.Label>Product Image</Form.Label>
                            <Form.Control
                                type="file"
                                accept=".jpg,.png,.jpeg"
                                name="image"
                                onChange={handleChange}
                            />
                        </Form.Group>

                        <Button variant="primary" type="submit" className="mt-3">
                            Add Product
                        </Button>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default AddProductPage;
